<template>
    <div class="friend">
        <div v-for="item in res" :key="item">{{item}}</div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            list: [
                "aisa",
                "tianxiang",
                "miguan"
            ]
        }
    },
    computed: {
        res() {
            let name = this.$route.query.name
            return this.list.filter(item => item != name)
        }
    }
}
</script>
<style>
.friend{
    color: red;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 20px;
    height: 300px;
    justify-items: center;
    align-items: center;
}
</style>